// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { useStepFormInputContext } from "@store/Framework/Store/Context/StepFormInputContext";
import {
    CreditFormContext,
    StepFormValidationDictionary,
} from "@store/Library/Widgets/CreditForm/CreditFormContextContainer";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import React from "react";

interface UseStepFormInputParams {
    inputKey: string;
    stepOverride?: number;
    required: boolean;
    validation?: ((value: string) => string | undefined) | keyof StepFormValidationDictionary;
    value?: string;
}

const useStepFormInputs = ({
    required,
    inputKey,
    stepOverride,
    validation,
    value: valueOverride,
}: UseStepFormInputParams) => {
    const { validationDictionary, storeKey: formKey = "" } = React.useContext(CreditFormContext) || {};

    const { currentStep: contextCurrentStep, editable, hasSubmitted } = useStepFormInputContext();
    const stepToUse = stepOverride ?? contextCurrentStep;
    const dispatch = useBunzlDispatch();
    const stepInput = useAppSelector(
        state => toToolkitApplicationState(state).bunzl.pages.stepForm[formKey]?.steps[stepToUse]?.inputs[inputKey],
    );

    const { value, isValid } = stepInput || { value: "", isValid: false };
    const valueToUse = valueOverride ?? value;
    const validationFunction = typeof validation === "string" ? validationDictionary?.[validation] : validation;

    let error: string | undefined = "";
    if (validationFunction && required && hasSubmitted) {
        error = validationFunction(valueToUse);
    }

    const handleDispatch = (value: string, isValid: boolean, required: boolean) => {
        dispatch({
            type: "Data/StepForm/UpdateStepForm",
            formKey,
            inputKey,
            value,
            stepIndex: stepToUse,
            isValid,
            required,
        });
    };

    if (typeof window !== "undefined") {
        // checking for valueOverride as we do not want to set the input in the redux store if we're controlling the component
        if (!stepInput && valueOverride === undefined) {
            dispatch({
                type: "Data/StepForm/UpdateStepForm",
                inputKey,
                formKey,
                value: "",
                stepIndex: stepToUse,
                isValid: false,
                required,
            });
        }
    }

    const handleChange = (value: string) => {
        const isValid = !validationFunction?.(value);
        handleDispatch(value, isValid, required);
    };
    return { value: valueToUse, handleChange, isValid, editable, error, hasSubmitted, handleDispatch };
};

export default useStepFormInputs;
